import { QueryClient } from '@tanstack/react-query';

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      // Mutationen immer ausführen: ohne Verbindung übernimmt die Offline-Warteschlange (PWA-03)
      mutations: { networkMode: 'always' },
    },
  });
}
